import React, { useState, useEffect, useMemo } from 'react';
import DashboardLayout from '../DashboardLayout';
import { useUsers } from '../../metodos/userContext';
import logo from '../../assets/logo.png';
import { 
  LayoutDashboard, Calculator, MessageSquare, 
  Settings, Menu as MenuIcon, X,
   CalendarDays, Grid3X3, BarChart3, ChevronRight, ChevronDown,
  Users, Receipt, 
   Landmark
} from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../metodos/AuthContext';
import { useDashboardModel } from '../../modelos/Dashboard/modeloDashboard';
import { useConfiguracion } from '../../metodos/ConfiguracionContext';
import { obtenerNombreEmpresaReal } from '../../config/unificacion';

const routes = [ 
  //solicitudes
  { 
    name: "Cotizar", 
    icon: <Calculator size={20} />, 
    path: "/dashboard",
    permission: 'permiso_solicitudes',
    hasSubmenu: true,
    submenu: [
      { name: "Cotizaciones", icon: <Grid3X3 size={16} />, path: "/dashboard",permission: 'permiso_solicitudes'},
      { name: "proPlataforma", icon: <BarChart3 size={16} />, path: "/dashboard/plataforma",permission: 'permisoTesis'},
      { name: "Tesis Manager", icon: <BarChart3 size={16} />, path: "/dashboard/tesis_manager",permission: 'permisoProPlataforma'},
    ]
  },
  //Dashboard
  { 
    name: "Dashboard", 
    icon: <LayoutDashboard size={20} />,
    path: "/dashdashv2",
    permission: 'permiso_tutores',
  },
  //Recursos humanos
  { 
    name: "Recursos Humanos", 
    icon: <Users size={20} />,
    path: "/tutores",
    permission: 'permiso_tutores',
  },
  //Estadisticas
  { 
    name: "Estadisticas", 
    icon: <BarChart3 size={20} />, 
    path: "/estadisticas",
    permission: 'permiso_estadisticasPlataforma',
    hasSubmenu: true,
    submenu: [
      { name: "Estadisticas", icon: <Grid3X3 size={16} />, path: "/estadisticas",permission: 'permiso_estadisticasPlataforma'},
      { name: "Marketing", icon: <BarChart3 size={16} />, path: "/estadisticas/marketing",permission: 'permiso_estadisticasPlataforma'},
    ]
  },
  //Calendario
  { 
    name: "Calendario", 
    icon: <CalendarDays size={20} />, 
    path: "/calendario",
    hasSubmenu: false,
    permission: 'permisoCalendario',
  },
  //Sistemas de clientes, marketing aca
  { 
    name: "Clientes", 
    icon: <Users size={20} />, 
    path: "/clientes",
    permission: 'permisoClientes',
  },
  //Sistema de contabilidad
  { 
    name: "Contabilidad ", 
    icon: <Landmark size={20} />, 
    path: "/contabilidad/registrar_pagos",
    permission: 'permiso_contabilidad_central',
    hasSubmenu : true,
    submenu: [
      { name: "Pagos", icon: <Grid3X3 size={16} />, path: "/contabilidad/registrar_pagos",permission: 'permiso_contabilidad_central'},
      //{ name: "Servicios", icon: <Grid3X3 size={16} />, path: "/contabilidad",permission: 'permiso_contabilidad_central'},
      { name: "Costos", icon: <Grid3X3 size={16} />, path: "/contabilidad/costos",permission: 'permiso_contabilidad_central'},
    ],
  },
  //cuentas de cobro
  { 
    name: "Cuentas de cobro", 
    icon: <Receipt size={20} />,  
    path: "/cuentasDeCobro",
    permission: 'permisoCuentaCobro',
  },
  //configuracion
  { 
    name: "Configuracion", 
    icon: <Settings size={20} />, 
    path: "/configuracion",
    hasSubmenu: false,
    submenu: [
      { name: "Configuracion", icon: <Grid3X3 size={16} />, path: "/configuracion",permission: 'permiso_configuracionGeneral'},
    ],
    permission: 'permiso_configuracionGeneral',
  },
  //Centro de informacion
  { 
    name: "Centro de informacion", 
    icon: <LayoutDashboard size={20} />,
    path: "/proPlataforma",
    hasSubmenu: true,
    submenu: [
      { name: "Pro Plataformas", icon: <Grid3X3 size={16} />, path: "/proPlataforma",permission: 'permiso_solicitudes'},
      //{ name: "Guardador", icon: <LayoutDashboard size={16} />, path: "/guardador",permission: 'permiso_tutores'},
      //{ name: "Agregar Variables", icon: <Grid3X3 size={16} />, path: "/proPlataforma/agregar",permission: 'permiso_configuracionGeneral'},

    ]
  },
  //Correos
  { 
    name: "Correo", 
    icon: <Users size={20} />, 
    path: "/enviarCorreo",
  },
  //whatsapp
  { 
    name: "Whatsapp", 
    icon: <MessageSquare size={20} />, 
    path: "/whatsapp/embudo",
    hasSubmenu: true,
    submenu: [
      { name: "Chat", icon: <Grid3X3 size={16} />, path: "/whatsapp"},
      { name: "Embudo", icon: <Grid3X3 size={16} />, path: "/whatsapp/embudo"},
    ],
  }
];

const HomeScreenAdmin = () => {

  const { usuario} = useUsers();
  const navigate = useNavigate();
  const location = useLocation();
  const {configuracion} = useConfiguracion();
  let nombreEmpresaReal =  obtenerNombreEmpresaReal(configuracion.nombreEmpresa);
  const {
    estadisticasTrabajosNoEntregados,
    cargarEstadisticasServiciosNoEntregados,

    estadistigasAsesoriasPendientes,
    cargarEstadisticasAsesorias,

    solicitudPorAgendar,
    cargarsolicitudesPorAgendar,

    serviciosPorRevisar,
    cargarServiciosRevision,
  } = useDashboardModel();

  const conteoPagos = 3; 
  const conteoChats = 12;

  useEffect(() =>{
    if (nombreEmpresaReal) {
      cargarEstadisticasServiciosNoEntregados(nombreEmpresaReal);
      cargarEstadisticasAsesorias(nombreEmpresaReal);
      cargarsolicitudesPorAgendar(nombreEmpresaReal);
      cargarServiciosRevision(nombreEmpresaReal);
    }
  },[]);

  //conteos
  const conteoTrabajosVencidos = estadisticasTrabajosNoEntregados?.length || 0;
  const asesoriaSinGrabacion = estadistigasAsesoriasPendientes?.length || 0;
  const solicitudesPorAgendar = solicitudPorAgendar?.length || 0;
  const conteoRevisiones = serviciosPorRevisar?.length || 0;

  const conteoDashboard = conteoTrabajosVencidos + asesoriaSinGrabacion + solicitudesPorAgendar + conteoRevisiones;

  const conteoCalendario = 0;
  const conteoCuentasCobro = 0;

  //filtrado de rutas
  const filteredRoutes = useMemo(() => {
    if (!usuario || !usuario.permisosUsuario) return [];

    const userPermissions = usuario.permisosUsuario;

    return routes
      .map(route => {
        // --- 2. INYECCIÓN DE BADGES EN SUBMENÚS ---
        const visibleSubmenus = route.submenu?.map(subItem => {
          const hasPermission = !subItem.permission || userPermissions[subItem.permission] === true;
          if (!hasPermission) return null;

          // Inyectar badge al submenú específico
          let subBadge = 0;
          //if (subItem.name === "Pagos") subBadge = conteoPagos;

          return { ...subItem, badge: subBadge };
        }).filter(Boolean) || [];

        // --- 3. INYECCIÓN DE BADGES EN MENÚ PRINCIPAL ---
        const hasMainPermission = !route.permission || userPermissions[route.permission] === true;
        const hasVisibleSubmenus = visibleSubmenus.length > 0;

        if (hasMainPermission || hasVisibleSubmenus) {
          // Lógica para el badge del padre:
          // Puedes sumar los badges de los hijos o poner uno específico
          let mainBadge = route.badge || 0; 
          
          if (route.name === "Whatsapp") {
            //mainBadge = conteoChats;
          } else if (route.name === "Contabilidad ") {
            // Sumamos todos los badges de sus submenús (Pagos + Costos, etc)
            //mainBadge = visibleSubmenus.reduce((acc, sub) => acc + (sub.badge || 0), 0);
          } else if (route.name == "Dashboard"){
            mainBadge = conteoDashboard;
          }

          return { 
            ...route, 
            submenu: visibleSubmenus,
            badge: mainBadge 
          };
        }
        
        return null;
      })
      .filter(Boolean);

  }, [usuario, conteoPagos, conteoChats, conteoDashboard]);

  useEffect(() => {
    // No hagas nada si las rutas aún no se han calculado o no hay ninguna disponible
    if (filteredRoutes.length === 0) {
      return; 
    }

    // 1. Define la ruta de destino: la primera en la lista filtrada
    const firstAvailablePath = filteredRoutes[0].path;

    // 2. Obtén la ruta del primer submenú, si existe
    const firstSubmenuPath = filteredRoutes[0].submenu?.[0]?.path;

    // 3. Elige la ruta del submenú si existe, si no, la del menú principal
    const destinationPath = firstSubmenuPath || firstAvailablePath;

    // 4. Comprueba si el usuario está en la ruta raíz del dashboard ('/dashboard')
    // y si esa ruta de destino es diferente.
    if (location.pathname === '/dashboard' && location.pathname !== destinationPath) {
      console.log(`Redirigiendo de /dashboard a ${destinationPath}`);
      // Redirige al usuario a la primera ruta que tiene disponible
      navigate(destinationPath, { replace: true });
    }

  }, [filteredRoutes, location.pathname, navigate]); // Dependencias del efecto


  return (
    <DashboardLayout 
      routes={filteredRoutes} // Pasamos las rutas ya filtradas
      user={usuario}          // Pasamos el usuario para el Topbar
      appTitle="Portal administrador / colaborador"
      customLogo={logo}
    />
  );

}

export default HomeScreenAdmin
